import { call, put, takeLatest } from "redux-saga/effects";
import * as dashboardApis from "../apis/dashboardApis"
import { DASHBOARD, DASHBOARD_LOW_STOCK_PRODUCTS, DASHBOARD_MONTHLY_SALES, DASHBOARD_OUTOFSTOCK_PRODUCTS, LOGIN } from "../actions/types";

export function* dashboardWorker(action) {
    try {
        const res = yield call(dashboardApis.dashboardApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* dashboardMonthlySalesWorker(action) {
    try {
        const res = yield call(dashboardApis.dashboardMonthlySalesApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* dashboardOutOfStockProductsWorker(action) {
    try {
        const res = yield call(dashboardApis.dashboardOutOfStockProductsApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* dashboardLowStockProductsWorker(action) {
    try {
        const res = yield call(dashboardApis.dashboardLowStockProductsApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}


/**Watcher functions */

export function* dashboardWatcher() {
    yield takeLatest(DASHBOARD, dashboardWorker);
}

export function* dashboardMonthlySalesWatcher() {
    yield takeLatest(DASHBOARD_MONTHLY_SALES, dashboardMonthlySalesWorker);
}

export function* dashboardOutOfStockProductsWatcher() {
    yield takeLatest(DASHBOARD_OUTOFSTOCK_PRODUCTS, dashboardOutOfStockProductsWorker);
}

export function* dashboardLowStockProductsWatcher() {
    yield takeLatest(DASHBOARD_LOW_STOCK_PRODUCTS, dashboardLowStockProductsWorker);
}